import React, { useContext } from 'react';
import PaymentMethodItem from 'components/payment/PaymentMethodItem';
import { useAppDispatch, useAppSelector } from 'lib/hooks/redux';
import { setPaymentMethod as setAlignet } from 'store/paymentMethod/alignet.slice';
import { useTranslation } from 'react-i18next';
import { ErrorContext } from 'containers/aio/PaymentMethodsContainer/context';
import { useDeliveryMethod } from 'lib/hooks/deliveryMethod';
import { RootState } from 'types/store';
import { useDisabledMessage } from 'lib/hooks/disabledMessage';
import { useRules } from 'lib/hooks/rules';

/**
 * AlignetSelector shows the option to select AlignetSelector as payment method
 * @returns JSX.Element
 */
export function AlignetSelector(): JSX.Element {
    const { t } = useTranslation('error');
    const dispatch = useAppDispatch();
    const ctx = useContext(ErrorContext);
    const pm = useAppSelector((state) => state.paymentMethod);
    const dm = useDeliveryMethod();
    const couponLoading = useAppSelector(
        (state: RootState) => state.coupon.status === 'pending' || state.cart.status !== 'ok',
    );
    const isSelected = pm.data.selected.includes('Alignet');
    const isLoading = pm.data.loading.includes('Alignet');
    const isBlocked =
        (pm.data.status === 'pending' && !isLoading) || couponLoading || !dm.hasSchedules();
    const disabledMessage = useDisabledMessage().find((dm) => dm.paymentMethod == 'Alignet')
        ?.disabledMessage;
    const rules = useRules();

    async function setAlignetPayment() {
        try {
            await dispatch(setAlignet()).unwrap();
        } catch (e) {
            ctx.setError(t('defaultPaymentError.message'));
        }
    }

    return (
        <PaymentMethodItem
            paymentMethodName="Tarjeta Ripley Crédito"
            type="ripleycredito"
            widthIcon="70px"
            onClick={setAlignetPayment}
            selected={isSelected}
            blocked={isBlocked}
            isLoading={isLoading}
            disabled={disabledMessage && !rules.feature('Alignet')}
        />
    );
}
